'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { Card } from '@morpho-org/ui-v6/server';
import { isVaultV2RateCapped } from '@/helpers/vaultV2RateCap';
import type { VaultV2ApyOverviewData } from './VaultV2ApyOverview.mapper';
import { V2RateCard, VaultV2ChartApyCard } from './components';
export interface ApyCardClientProps {
  apyOverview: VaultV2ApyOverviewData;
  now: number;
  vaultAddress: Address;
  chainId: ChainId;
}
const VaultV2ApyClient = t0 => {
  const $ = _c(16);
  const {
    apyOverview,
    now,
    vaultAddress,
    chainId
  } = t0;
  let t1;
  if ($[0] !== apyOverview.grossApy || $[1] !== apyOverview.maxApy) {
    t1 = isVaultV2RateCapped(apyOverview.grossApy, apyOverview.maxApy);
    $[0] = apyOverview.grossApy;
    $[1] = apyOverview.maxApy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isRateCapped = t1;
  let t2;
  if ($[3] !== apyOverview || $[4] !== chainId || $[5] !== now || $[6] !== vaultAddress) {
    t2 = <Card className="py-lg px-md lg:contents" withBorder={true}><VaultV2ChartApyCard apyOverview={apyOverview} now={now} vaultAddress={vaultAddress} chainId={chainId} /></Card>;
    $[3] = apyOverview;
    $[4] = chainId;
    $[5] = now;
    $[6] = vaultAddress;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== apyOverview || $[9] !== chainId || $[10] !== isRateCapped || $[11] !== vaultAddress) {
    t3 = <Card padding="s" withBorder={true} className="flex-col lg:contents"><V2RateCard apyOverview={apyOverview} vaultAddress={vaultAddress} chainId={chainId} isRateCapped={isRateCapped} /></Card>;
    $[8] = apyOverview;
    $[9] = chainId;
    $[10] = isRateCapped;
    $[11] = vaultAddress;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <div className="gap-sm lg:gap-lg lg:border-border lg:bg-card lg:p-lg flex w-full flex-col lg:flex-row lg:rounded-[20px] lg:border-[0.5px] lg:shadow-md dark:lg:shadow-none">{t2}{t3}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default VaultV2ApyClient;